import React, { useState } from 'react';
import Dropdown from './Dropdown';
import VideoCarousel from './VideoCarousel';
import Hero from './Hero';

const FilteredVideoCarousel = () => {
  const [selectedFormat, setSelectedFormat] = useState('All');
  const [nextAdIndex, setNextAdIndex] = useState(9);

  return (
    <div>
      <Hero showCopy={true} setNextAdIndex={setNextAdIndex} />
      <div className="marginContainer">
        <div className="">
          <div className="container">
            <Dropdown selectedFormat={selectedFormat} setSelectedFormat={setSelectedFormat} nextAdIndex={nextAdIndex} setNextAdIndex={setNextAdIndex}/>
          </div>
        </div>
        <VideoCarousel  selectedFormat={selectedFormat} nextAdIndex={nextAdIndex} setNextAdIndex={setNextAdIndex} />
      </div> 
    </div>
  );
};

export default FilteredVideoCarousel;
